/**
 * @Author: wuyang
 * @Date: 2024/1/25
 * @Description: 对接不同 Service 所使用的 socket
 */
import {
	BaseAbstractClass,
	IBaseAbstractClassProps
} from '@/helper/base/BaseAbstractClass'
import { getSocketIOInstance } from '@/api/socket'
import { ESocketPushType, ISocketDataByType } from '@/types/socket'
import { Handler } from 'mitt'

export interface ISocketServiceProps extends IBaseAbstractClassProps {}

export class SocketService extends BaseAbstractClass<ISocketServiceProps> {
	private socketIOInstance = getSocketIOInstance()
	constructor(props: ISocketServiceProps) {
		super(props)
		this.socketIOInstance.addSocketService(this)
	}

	on<T extends ESocketPushType>(
		eventHandle: T,
		callback: Handler<ISocketDataByType[T]>
	) {
		this.mitt.on(eventHandle, callback)
	}

	destory() {
		super.destory()
		this.socketIOInstance.delSocketService(this)
	}
}

export const createSocketService = (props: ISocketServiceProps) => {
	return new SocketService(props)
}
